var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPin = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 55,
  height: 60,
  viewBox: "17 11 21 30",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.1622 11C20.777 11 15 15.9092 15 23.5016C15 28.3498 18.7247 34.0517 26.1588 40.6227C26.7365 41.1258 27.603 41.1258 28.1807 40.6227C35.5997 34.0517 39.3243 28.3498 39.3243 23.5016C39.3243 15.9092 33.5473 11 27.1622 11ZM27.1622 26.2458C25.4899 26.2458 24.1216 24.8737 24.1216 23.1967C24.1216 21.5196 25.4899 20.1475 27.1622 20.1475C28.8345 20.1475 30.2027 21.5196 30.2027 23.1967C30.2027 24.8737 28.8345 26.2458 27.1622 26.2458Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };